import { render, staticRenderFns } from "./FoxCheckboxGroup.vue?vue&type=template&id=81360e66&"
import script from "./FoxCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FoxCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./FoxCheckboxGroup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports